import { WithCopy } from '@scale/frontend-lib/sensor-fusion';

import { CORP_LOOKUP_PATH, REMOADMIN_LOOKUP_PATH } from '../constants';
import { useMemo } from 'react';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

type LookupIdLinkProps = {
  className?: string;
  id: string;
};

const LookupIdLink = ({ className, id }: LookupIdLinkProps) => {
  const { isRemoAdmin } = useRemoAdminCtx();

  const lookupLink = useMemo(
    () => (isRemoAdmin ? `/${REMOADMIN_LOOKUP_PATH}/${id}` : `/${CORP_LOOKUP_PATH}/${id}`),
    [isRemoAdmin, id],
  );

  return (
    <WithCopy className={className} copyText={id}>
      <a className="text-info-700" href={lookupLink}>
        {id}
      </a>
    </WithCopy>
  );
};

export default LookupIdLink;
